module.exports = __webpack_public_path__ + "img/LogoUbuken_Color.17728656.png";